import React, { useState } from 'react';
import { apiCall } from '../config/api-request';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

function Login() {
    const navigate = useNavigate();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const sendOtp = async () => {
        if (phoneNumber.length < 11) {
            alert('Please enter valid mobile number');
            return;
        }
        setLoading(true);

        try {
            const result = await apiCall(
                {
                    api: 'login-admin',
                    number: phoneNumber
                },
                false
            );

            if (result.status === true) {
                setLoading(false);
                setOtpSent(true);
            } else {
                toast.error(result.message || "Failed to load form data");
            }
        } catch (error) {
            console.error("Error fetching operator form:", error);
            toast.error("Failed to load form data");
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = async () => {
        if (otp.length !== 6) {
            alert('Please enter 6 digit OTP');
            return;
        }
        setLoading(true);

        try {
            const result = await apiCall(
                {
                    api: 'otp-verify-admin',
                    number: phoneNumber,
                    otp: otp
                },
                false
            );

            if (result.status === true) {
                if (result.data.user_type === "3") {
                    setLoading(false);
                    setOtpSent(true);
                    localStorage.setItem("session_data", JSON.stringify(result.data));
                    navigate('../dashboard', { replace: true });
                } else {
                    toast.error("Contact system developer");
                }
            } else {
                toast.error(result.message || "Failed to load form data");
            }
        } catch (error) {
            console.error("Error fetching operator form:", error);
            toast.error("Failed to load form data");
        } finally {
            setLoading(false);
        }
    };

    const changeNumber = () => {
        setOtpSent(false);
        setOtp('');
        setPhoneNumber('');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-xl p-8 w-full max-w-md">
                {/* Logo */}
                <div className="flex justify-center mb-6">
                    <div className="bg-blue-600 rounded-xl p-3">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h2 className="text-2xl font-semibold text-center text-gray-800 mb-2">Welcome Back</h2>
                <p className="text-center text-gray-500 text-sm mb-8">Login to your account</p>

                {/* Mobile Number Field */}
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Mobile Number</label>
                    <div className="flex">
                        <span className="inline-flex items-center px-3 bg-gray-50 border border-r-0 border-gray-300 rounded-l-md text-gray-600 text-sm">
                            +49
                        </span>
                        <input
                            type="tel"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 11))}
                            disabled={otpSent}
                            className={`flex-1 px-3 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm ${otpSent ? 'bg-gray-100 text-gray-500' : ''
                                }`}
                            placeholder="9876543210"
                        />
                    </div>
                </div>

                {/* Send OTP Button - Hide after OTP sent */}
                {!otpSent && (
                    <button
                        onClick={sendOtp}
                        disabled={loading}
                        className="w-full bg-gray-600 text-white py-2 rounded-md hover:bg-gray-700 transition disabled:opacity-50 text-sm font-medium mb-4"
                    >
                        {loading ? 'Sending...' : 'Send OTP'}
                    </button>
                )}

                {/* OTP Field - Show only after OTP sent */}
                {otpSent && (
                    <>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Enter OTP</label>
                            <input
                                type="text"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center text-lg tracking-wider"
                                placeholder="123456"
                                autoFocus
                            />
                        </div>

                        {/* Change Number Button */}
                        <button
                            onClick={changeNumber}
                            className="w-full text-blue-600 text-sm py-2 hover:text-blue-700 transition mb-4"
                        >
                            ← Change Mobile Number
                        </button>

                        {/* Login Button */}
                        <button
                            onClick={handleLogin}
                            disabled={loading}
                            className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition disabled:opacity-50 text-sm font-medium"
                        >
                            {loading ? 'Verifying...' : 'Login'}
                        </button>
                    </>
                )}

                {/* Footer */}
                <p className="text-center text-gray-400 text-xs mt-6">
                    By continuing, you agree to our Terms & Privacy Policy
                </p>
            </div>
            <Toaster />
        </div>
    );
}

export default Login;